export const rhinovideoVideoStreamId = 'rhinovideo__participant-stream__video__';
export const rhinovideoScreenShareStreamId = 'rhinovideo__participant-stream__screenshare';
export const rhinovideoAudioStreamId = 'rhinovideo__participant-stream__audio__';
